import { FloorAcl, FloorAclGroups, FloorAclMembers } from '@era/locations-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const FloorPermissionsResolverActions = createActionGroup({
  source: 'Floor Permissions Resolver',
  events: {
    'Floor acl requested': props<{ resourceId: string; locationResourceId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AccessControlListApiActions = createActionGroup({
  source: 'Access Control List Controller',
  events: {
    'Floor acl loaded': props<{ floorAcl: FloorAcl }>(),
    'Floor acl loaded error': props<{ error: ErrorModel }>(),
    'Floor acl member put': props<{ aclMember: FloorAclMembers }>(),
    'Floor acl group put': props<{ aclGroup: FloorAclGroups }>(),
    'Floor acl group remove': props<{ aclGroup: FloorAclGroups }>(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const FloorAclPermissionsUiActions = createActionGroup({
  source: 'Floor Settings Acl Permissions Component',
  events: {
    'Floor acl member put': props<{ aclMember: FloorAclMembers }>(),
    'Floor acl group put': props<{ aclGroup: FloorAclGroups }>(),
    'Floor acl group remove': props<{ aclGroup: FloorAclGroups }>(),
  },
});
